import React from 'react';
import clsx from 'clsx';

import Chip from '@material-ui/core/Chip'

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => (
    {
     chipPink: {
        backgroundColor: '#906e91',
        color: 'white',
        fontWeight: 'bold',
      },
      chipBlue: {
        backgroundColor: '#1686c7',
        color: 'white',
        fontWeight: 'bold',
      },
      chipGreen: {
        backgroundColor: '#5fb36f',
        color: 'white',
        fontWeight: 'bold',
      },
      chipOrange: {
        backgroundColor: '#f76f14',
        color: 'white',
        fontWeight: 'bold',
      },
      marginChip: {
        marginRight: '1px',
        marginLeft: '1px',
      },
    }
  )
);

export const Legenda = ({ params }) => {
  const classes = useStyles();
  return (
    <>
      <Chip size="small" label={params[0]} className={clsx(classes.chipBlue, classes.marginChip)}></Chip>
      { params[1] != null ? <Chip size="small" label={params[1]} className={clsx(classes.chipPink, classes.marginChip)}/> : null }
      { params[2] != null ? <Chip size="small" label={params[2]} className={clsx(classes.chipGreen, classes.marginChip)}/> : null }
      { params[3] != null ? <Chip size="small" label={params[3]} className={clsx(classes.chipOrange, classes.marginChip)}/> : null }
    </>
  )
}

export default Legenda;